<script setup>
import ScorePill from './ScorePill.vue';

// Each row is a pre-built descriptor (built by ReportSummaryPanel, which knows
// the key-ordering/tooltip/highlight rules specific to each table) rather than
// a raw [key, value] pair — keeps this component a pure renderer.
defineProps({
	rows: { type: Array, required: true }
});
</script>

<template>
	<div class="tnt-summary-list" style="display: block">
		<div
			v-for="row in rows"
			:key="row.key"
			class="tnt-summary-item"
			:class="row.rowClass"
		>
			<div class="tnt-summary-label">
				{{ row.label }}
				<button v-if="row.tooltip" type="button" class="tnt-info-trigger">
					<span class="tnt-info-tip" role="tooltip">{{ row.tooltip }}</span>
				</button>
			</div>
			<div class="tnt-summary-value" :class="row.valueClass">
				<ScorePill v-if="row.isScore" :value="row.rawValue" :field-key="row.key" />
				<span v-else-if="row.isBoolean" class="tnt-status-chip" :class="row.boolValue ? 'tnt-status-ok' : 'tnt-status-alert'">
					{{ row.boolValue ? 'PASS' : 'FAIL' }}
				</span>
				<div v-else-if="row.displayEntries && row.displayEntries.length" class="tnt-value-lines">
					<ul v-for="(entry, i) in row.displayEntries.filter(e => e.type === 'bullet-list')" :key="'bl' + i" class="tnt-value-list">
						<li v-for="(item, j) in entry.items" :key="j">{{ item }}</li>
					</ul>
					<div v-for="(entry, i) in row.displayEntries.filter(e => e.type !== 'bullet-list')" :key="i" class="tnt-value-object-row">
						<template v-if="entry.type === 'text'">{{ entry.text }}</template>
						<template v-else>
							<span class="tnt-value-object-key">{{ entry.label }}:</span>
							<ScorePill v-if="entry.type === 'object-row' && (entry.key === 'confidence_score' || entry.key === 'data_completeness')" :value="entry.value" :field-key="entry.key" />
							<span v-else>{{ entry.children ? entry.children.map(c => c.text).join(', ') : entry.value }}</span>
						</template>
					</div>
				</div>
				<span v-else>{{ row.text }}</span>
			</div>
		</div>
	</div>
</template>
